import { ApiResponse, axiosInstance } from '@/lib/axios';
import { MutationConfig } from '@/lib/react-query';
import { useMutation } from '@tanstack/react-query';

export const signOut = async (): Promise<ApiResponse<{ message: string }>> => {
  const url = '/auth/logout';
  return axiosInstance.post(url);
};

type UseSignOutOptions = {
  mutationConfig?: MutationConfig<typeof signOut>;
};

export const useSignOut = ({ mutationConfig }: UseSignOutOptions) => {
  const { ...rest } = mutationConfig || {};

  return useMutation({
    ...rest,
    mutationFn: signOut,
  });
};
